import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Col, Row, Modal, UncontrolledAlert, Spinner } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { apiError } from "store/actions"
import api from "API/Api"
import { Link } from "react-router-dom"

const EditCanType = props => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [canData, setCanData] = useState([])

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    const response = await api.get("can-type/" + id)
    setCanData(response.data.data[0])
  }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    const update = await api.put("update-can/" + id, values)
    if (update.data.success === true) setSubmitted(true)
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }
  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Edit Can Type</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/can-types" className="dashBtn">
                <i className=" fas fa-chevron-left "></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            className="form-horizontal"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v)
            }}
          >
            <div className="mb-3">
              <AvField
                name="canName"
                label="Can Type Name"
                value={canData.canName}
                className="form-control"
                placeholder="Enter Can Type Name"
                type="text"
                required
              />
            </div>

            <div className="mb-3">
              <AvField
                name="weight"
                label="Can Type Weight"
                value={canData.weight}
                className="form-control"
                placeholder="Enter Can Type Weight"
                type="text"
                required
              />
            </div>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Can Type is Updated!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Updating...</span>
                    </>
                  ) : (
                    <span>Update Can Type</span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default EditCanType
